import {IListViewField} from "../../../../Shared/ILIstViewField";
import {OldNewDocumentListView} from "../../../../Shared/NewDocumentTabView";
import {AppEntities} from "../../../../../config/entities";

const ConsumptionOrdersList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <OldNewDocumentListView fields={fields} entity={AppEntities.ConsumptionOrders} />
        </>
    );
}

export default ConsumptionOrdersList;